'use strict';

export default function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('oem_main.device_config_create', {
    url: '/company/:company_id/device_config_create',
    template: '<oem-device-config-create></oem-device-config-create>',
    params: { id: null }
  });
};



// WEBPACK FOOTER //
// ./public/dev/app/oem/device_config/create/device_config_create.routes.js